
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import editar from './utiles-respuestas-editar.vue';
    import { RespuestaPredefinida } from '@/__env/lib/Preguntas/RespuestaPredefinida';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            editar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        public Cargando: boolean = false;
        public Seleccionada: RespuestaPredefinida = null;
        public Respuestas: RespuestaPredefinida[] = [];

        async mounted()
        {
            this.Controlador.BarraLateralWidth = 325;
            await this.Buscar();
        }

        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        async onBusqueda()
        {
            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Buscar();
            }
        }
        async Buscar( forzar?: boolean )
        {
            if ( forzar )
            {
                this.Busqueda = '';
            }

            this.Respuestas.clear();
            this.Cargando = true;
            let ff: any = {

            };
            if ( this.Busqueda )
                ff.q = this.Busqueda;
            let e = await RespuestaPredefinida.find( ff );
            if ( e.Items.hasRows() )
            {
                this.Respuestas = e.Items;
            }
            this.Cargando = false;
        }

        public Editando: boolean = false;
        Editar( x: RespuestaPredefinida )
        {
            this.Seleccionada = x;
            this.Editando = !this.Editando;
        }

        async Eliminar( x: RespuestaPredefinida )
        {
            if ( await Utiles.Mensajes.SiNo( 'Eliminar respuesta', '¿Eliminar esta respuesta rápida?' ) )
            {
                let e = await x.del();
                if ( e )
                {
                    Utiles.Notificaciones.Completado( 'Eliminada correctamente!' );
                    this.Recargar();
                } else
                {
                    Utiles.Notificaciones.Error( 'Error al Eliminar' );
                }
            }
        }

        Nueva()
        {
            this.Seleccionada = new RespuestaPredefinida();
            this.Editando = !this.Editando;
        }

        Utilizar( x: RespuestaPredefinida )
        {
            if ( this.Controlador.Seleccionada )
                this.Controlador.EnviarARespuesta( x.Formatear( this.Controlador.Seleccionada ) );
        }

        async Recargar()
        {

            this.Busqueda = '';
            await this.Buscar();
        }
    }
